import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type TypeModalStore = {
  modal: TypeModal;
  actions: {
    setModal: (modal: TypeModal) => void;
    resetModal: () => void;
  };
};

/** @description common 모달에 사용되는 state의 형태 */
export type TypeModal = {
  /** 렌더링 여부 */
  open: boolean;
  /** 모달 타입 */
  type?: 'alert' | 'confirm';
  /** 타이틀 표시 */
  title?: string;
  /** 모달에 표시될 메시지 */
  message: string;
  /** 모달 컨텐츠에 표시할 요소 */
  customContent?: React.ReactNode;
  /** 확인 버튼에 표시될 메시지 */
  confirmText?: string;
  /** 취소 버튼에 표시될 메시지 */
  cancelText?: string;
  /** 확인 버튼 클릭 시 발생할 이벤트 */
  onConfirm?: () => void | Promise<void>;
};

const initialState: TypeModal = {
  open: false,
  type: 'alert',
  title: '',
  message: '',
  customContent: undefined,
  confirmText: '확인',
  cancelText: '취소',
  onConfirm: () => undefined,
};

/** @description 전역 모달에 사용되는 모달 표시 여부 및 모달 관련 정보를 가지고 있는 상태 */
export const useModalStore = create<TypeModalStore>()(
  devtools((set) => ({
    modal: initialState,
    actions: {
      setModal: (modal: TypeModal) => set({ modal }),
      resetModal: () => set({ modal: initialState }),
    },
  }))
);
